import { Component } from '@angular/core';
import { soundpostPaymentLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Payment Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostpaymentline-form',
    templateUrl: './soundpostpaymentline.form.component.html'
})
export class soundpostPaymentLineFormComponent extends BaseFormComponent {
    public record!: soundpostPaymentLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

